export const NAME_MAX_LENGTH = 20;
export const NAME_KANA_MAX_LENGTH = 30;
export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 72;
export const PASSWORD_REGEXP = /^(?=.*?[a-z])(?=.*?\d)[!-~]+$/i;
export const HIRAGANA_REGEXP = /^[ぁ-ん\u2014\u2015\u30fc]+$/;
export const ORGANIZATION_MEMBERSHIP_CODE_REGEXP = /^\d{1,20}$/;
export const ZENKAKU_REGEXP = /^[^\u0020-\u007E\uFF61-\uFF9F]+$/;

export interface AccountRegistrationFormValues {
  password: string;
  password_confirmation: string;
  first_name: string;
  last_name: string;
  first_name_kana: string;
  last_name_kana: string;
  email: string;
  code: string;
  student_first_name_kana: string;
  student_last_name_kana: string;
}

export interface StudentInfo {
  id: string;
  code: string;
  organization_id: string;
  organization_name: string;
  grade: string;
  class_name: string;
  attendance_number: number;
  student_id: string;
  name: string;
}

export interface OrganizationMembershipValidationResponse {
  student: StudentInfo;
}

export interface RegistrationVerifyResponse {
  access_token: string;
}
